import {
  GridColumnNode,
  GridLeafColumn,
} from '@mui/x-data-grid/models/gridColumnGrouping';
import {
  GridColumnGroup,
  GridColumnGroupingModel,
  GridColumnLookup,
  GridColumnVisibilityModel,
  isLeaf,
} from '@mui/x-data-grid-premium';

export const getColumnGroupLeaves = (
  group: GridColumnGroup,
  callback: (field: string) => void,
) => {
  group.children.forEach((child) => {
    if (isLeaf(child)) {
      callback(child.field);
    } else {
      getColumnGroupLeaves(child, callback);
    }
  });
};

export const getColumnVisibilityState = (
  columnVisibilityModel: GridColumnVisibilityModel,
) => {
  const isColumnVisible = (field: string) =>
    typeof columnVisibilityModel[field] === 'undefined' ||
    columnVisibilityModel[field];
  const isColumnHidden = (field: string) => !isColumnVisible(field);

  return {
    isColumnHidden,
    isColumnVisible,
  };
};

export const filterEnabledGroupsAndFields = (
  columnLookup: GridColumnLookup,
  groupingModel?: GridColumnGroupingModel,
): GridColumnGroupingModel | undefined => {
  const filterEnabledGroupsAndFieldsLevel = (
    groupingModel?: (GridColumnNode | GridColumnGroup)[],
  ): GridColumnNode[] => {
    return (
      groupingModel?.filter((gm) => {
        if (gm.hasOwnProperty('groupId')) {
          const { children } = gm as GridColumnGroup;
          return filterEnabledGroupsAndFieldsLevel(children).length > 0;
        }

        if (gm.hasOwnProperty('field')) {
          const { field } = gm as GridLeafColumn;
          return !!columnLookup[field];
        }

        return false;
      }) ?? []
    );
  };

  return filterEnabledGroupsAndFieldsLevel(
    groupingModel,
  ) as GridColumnGroupingModel;
};
